import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { AddressEmissionAreaTypeModalComponent } from './address-modal-emission-area-type/address-emission-area-type-modal.component';
import { AddressModalComponent } from './address-modal.component';
import { AddressComponent } from './address.component';
import { GenericAddressModalComponent } from './components/generic-address-modal/generic-address-modal.component';

@NgModule({
    declarations: [
        AddressComponent,
        AddressModalComponent,
        AddressEmissionAreaTypeModalComponent,
        GenericAddressModalComponent
    ],
    imports: [
        CommonModule,
        CheckboxModule,
        DropdownModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        InputMaskModule,
        RadioButtonModule,
        ReactiveFormsModule,
        MVMSpinnerBtnModule,
        SharedDirectivesModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        AddressComponent,
        AddressModalComponent,
        AddressEmissionAreaTypeModalComponent
    ]
})
export class AddressModule {
}
